import React from "react";
import StyledBuyMeACoffee from "./styled";
// import { faCoffeeTogo } from "@fortawesome/pro-duotone-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const BuyMeACoffee = () => {
  return (
    <StyledBuyMeACoffee
      target="_blank"
      href="https://www.buymeacoffee.com/thomasguibert"
    >
      <svg width="24px" height="36px" viewBox="0 0 24 36" version="1.1">
        <title>Group</title>
        <desc>Created with Sketch.</desc>
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="Group-2" transform="translate(-17.000000, -7.000000)">
            <g id="Logo">
              <g id="Group-4" transform="translate(17.000000, 8.000000)">
                <g id="Group">
                  <g id="Logo" transform="translate(0.559947, 0.000000)">
                    <polygon
                      id="Fill-1"
                      fill="#99999955"
                      points="11.2752139 6.65517263 2.53594776 6.60250871 6.82755165 33.7158335 7.76390159 33.7158335 16.3471094 33.7158335 17.2834593 33.7158335 21.5750632 6.60250871"
                    />

                    <polygon
                      id="Fill-3"
                      fill="#FFFFFF"
                      points="0.0390145809 6.60252433 22.5894423 6.60252433 22.5894423 4.10216009 0.0390145809 4.10216009"
                    />
                    <polygon
                      id="Stroke-4"
                      stroke="#000000"
                      stroke-width="1.17043743"
                      points="0.0390145809 6.60252433 22.5894423 6.60252433 22.5894423 4.10216009 0.0390145809 4.10216009"
                    />
                    <polygon
                      id="Fill-6"
                      fill="#FFFFFF"
                      points="18.2198093 0.0390681913 12.8357971 0.0390681913 9.63660147 0.0390681913 4.25258931 0.0390681913 2.61397692 3.78961456 9.63660147 3.78961456 12.8357971 3.78961456 19.8584217 3.78961456"
                    />
                    <g
                      id="Group-11"
                      transform="translate(0.936350, 0.000000)"
                      stroke-width="1.17043743"
                    >
                      <polygon
                        id="Stroke-7"
                        stroke="#050505"
                        points="17.2834593 0.0390681913 11.8994472 0.0390681913 8.70025153 0.0390681913 3.31623937 0.0390681913 1.67762698 3.78961456 8.70025153 3.78961456 11.8994472 3.78961456 18.9220717 3.78961456"
                      />
                      <polygon
                        id="Stroke-9"
                        stroke="#000000"
                        points="10.3388639 6.65517263 0.0390145809 6.60250871 4.33061848 33.7158335 5.26696842 33.7158335 15.4107594 33.7158335 16.3471094 33.7158335 20.6387133 6.60250871"
                      />
                    </g>
                    <polygon
                      id="Fill-12"
                      fill="#FFFFFF"
                      points="21.8871799 14.2598898 11.6059795 14.2598898 10.8664191 14.2598898 0.585218713 14.2598898 2.50832543 25.0427106 11.2361993 24.9487126 19.9640731 25.0427106"
                    />
                    <polygon
                      id="Stroke-13"
                      stroke="#000000"
                      stroke-width="1.17043743"
                      points="21.8871799 14.2598898 11.6059795 14.2598898 10.8664191 14.2598898 0.585218713 14.2598898 2.50832543 25.0427106 11.2361993 24.9487126 19.9640731 25.0427106"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
      {/* <FontAwesomeIcon icon={faCoffeeTogo} /> */}
      <span>Buy me a coffee</span>
    </StyledBuyMeACoffee>
  );
};

export default BuyMeACoffee;
